document.addEventListener('DOMContentLoaded', function () {
    //get price
    const priceElement = document.querySelector('.product-price--original')
    if (!priceElement) return

    const priceText = priceElement.textContent.trim()
    const priceNumber = parseFloat(priceText.replace(/[^0-9.]/g, ''))

    const deductible = getDeductible(priceNumber)
    document.getElementById('deductibleAmount').innerText = deductible

    // see benefit toggle
    let benefitToggle = document.getElementById('toggleBenefits')
    let benefits = document.getElementById('warrantyBenefits')

    benefitToggle.addEventListener('click', function (e) {
        e.preventDefault()
        if (benefits.style.display === 'none') {
            benefits.style.display = 'block'
            benefitToggle.innerHTML =
                'Hide benefits<span class="arrow">˅</span>'
        } else {
            benefits.style.display = 'none'
            benefitToggle.innerHTML = 'See benefits<span class="arrow">›</span>'
        }
    })

    const warrantyVariantInfo = document.getElementById('warranty-variant-info')
    const addWarrantyButton = document.getElementById('addWarrantyToCartButton')
    let warrantyVariantId

    if (addWarrantyButton) {
        addWarrantyButton.addEventListener('click', addWarrantyToCart)
    }
    async function displayWarrantyProduct() {
        const variantInfoElement = document.getElementById(
            'variantInfoWarranty'
        )
        if (!variantInfoElement) {
            return
        }
        const gid = variantInfoElement.getAttribute('data-warranty')
        if (!gid) {
            displayNoWarrantyError()
            return
        }
        const variantId = gid.split('/').pop()

        // Fetch warranty variant details.
        const warrantyVariantData = await fetchWarrantyVariantDetails(variantId)
        if (warrantyVariantData) {
            // Display the variant information in the designated element.
            const warrantyHtml = `<span>Add 5-year Term Extended Warranty Service for $${warrantyVariantData.formattedPrice}</span>`
            if (warrantyVariantInfo) {
                warrantyVariantInfo.innerHTML = warrantyHtml
            }
            toggleAddToCartButton(true)
            toggleLoading(false)
        } else {
            displayNoWarrantyError()
        }
    }

    async function fetchWarrantyVariantDetails(variantId) {
        try {
            const response = await fetch(`/variants/${variantId}.js`)
            if (!response.ok) {
                displayUnexpectedError()
                return null
            }
            const variant = await response.json()
            warrantyVariantId = variant.id
            return {
                title: variant.title,
                formattedPrice: (variant.price / 100).toFixed(2),
            }
        } catch (error) {
            console.error('Error fetching warranty variant details:', error)
            displayNoWarrantyError()
            return null
        }
    }

    function addWarrantyToCart() {
        addItemToCart().then(() => {
            updateCartContents({ showOverlay: true })
        })
    }

    function addItemToCart() {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{ quantity: 1, id: warrantyVariantId }],
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to add item to cart')
                }
                return response.json()
            })
            .catch((error) => {
                console.error('Error adding item to cart:', error)
                displayCartAdditionError()
            })
    }

    function updateCartContents({ showOverlay = false } = {}) {
        fetch('?section_id=helper-cart')
            .then((response) => response.text())
            .then((text) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(text, 'text/html')
                const cartForm = doc.getElementById('AjaxCartForm').innerHTML
                const cartSubtotal =
                    doc.getElementById('AjaxCartSubtotal').innerHTML

                document.getElementById('AjaxCartForm').innerHTML = cartForm
                document.getElementById('AjaxCartSubtotal').innerHTML =
                    cartSubtotal

                document
                    .querySelectorAll('[data-header-cart-count]')
                    .forEach((element) => {
                        element.textContent = document.querySelector(
                            '#AjaxCartForm [data-cart-count]'
                        ).textContent
                    })
                document
                    .querySelectorAll('[data-header-cart-total]')
                    .forEach((element) => {
                        element.textContent = document.querySelector(
                            '#AjaxCartForm [data-cart-total]'
                        ).textContent
                    })

                if (showOverlay) {
                    showCartOverlay()
                }
            })
            .catch((error) => {
                console.error('Error updating cart contents:', error)
                displayCartAdditionError()
            })
    }

    function showCartOverlay() {
        if (
            !document.body.classList.contains('template-cart') &&
            KROWN.settings.cart_action === 'overlay'
        ) {
            document.getElementById('site-cart-sidebar').show()
            setTimeout(() => {
                document
                    .querySelector('#site-cart-sidebar [data-js-close]')
                    .focus()
            }, 200)
        }
    }

    //toggle
    function toggleLoading(isLoading) {
        const loadingSpinner = document.getElementById('loadingSpinner')
        const warrantyContent = document.getElementById('warranty-content')
        if (loadingSpinner) {
            loadingSpinner.style.display = isLoading ? 'block' : 'none'
        }
        if (warrantyContent) {
            warrantyContent.style.display = isLoading ? 'none' : 'flex'
        }
    }

    function toggleAddToCartButton(show) {
        if (addWarrantyButton) {
            addWarrantyButton.style.display = show ? 'flex' : 'none'
        }
    }

    //error handling
    function displayNoWarrantyError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>Please contact customer service with error code: W10001</span>'
        }
        toggleAddToCartButton(false)
    }

    function displayCartAdditionError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>There was an error adding warranty service to your cart. Please try again. (Error code: W10002)</span>'
        }
        toggleAddToCartButton(false)
    }

    function displayUnexpectedError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>An unexpected error occurred. Please try again or contact support. (Error code: W10003)</span>'
        }
        toggleAddToCartButton(false)
    }

    // On page load, display the warranty variant information.
    displayWarrantyProduct()

    const variantInfoWarrantyEl = document.getElementById('variantInfoWarranty')
    if (variantInfoWarrantyEl) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-warranty'
                ) {
                    displayWarrantyProduct()
                }
            })
        })
        observer.observe(variantInfoWarrantyEl, { attributes: true })
    }
})

function getDeductible(price) {
    if (price >= 150 && price <= 200) {
        return '$50'
    } else if (price <= 600) {
        return '$100'
    } else if (price <= 1200) {
        return '$150'
    } else if (price <= 3000) {
        return '$200'
    } else if (price > 3000) {
        return '$250'
    } else {
        return 'Not applicable'
    }
}
